// Mock data for The Medicine Market clone

export const siteConfig = {
  name: "MediCare Plus",
  tagline: "Your Trusted Online Pharmacy Partner",
  email: "support@medicareplus.com",
  phone: "+1-800-MED-CARE",
  rating: 4.9,
  reviewCount: 56,
};

export const topNavLinks = [
  { label: "Insurance Coverage", href: "#insurance" },
  { label: "Low Prescription & OTC Drugs", href: "#otc" },
  { label: "Trusted Site", href: "#trusted" },
  { label: "Official Blog", href: "#blog" },
];

export const categories = [
  { id: 1, name: "All Categories", slug: "all", hasDropdown: true },
  { id: 2, name: "Men's Health", slug: "mens-health" },
  { id: 3, name: "Women's Health", slug: "womens-health" },
  { id: 4, name: "Beauty & Skin Care", slug: "beauty-skincare" },
  { id: 5, name: "Vitamins & Supplements", slug: "vitamins" },
  { id: 6, name: "Official Blog", slug: "blog" },
];

export const heroSlides = [
  {
    id: 1,
    title: "Your Trusted Source for Genuine Medications",
    subtitle: "FDA-approved products with fast worldwide delivery",
    discount: "Up to 57% Off",
    features: ["Fast Shipping", "100% Genuine", "Best Prices"],
    image: "https://images.unsplash.com/photo-1631549916768-4119b2e5f926?w=600&h=400&fit=crop",
    bgColor: "from-teal-700 via-teal-600 to-emerald-600",
  },
  {
    id: 2,
    title: "Premium Quality Vitamins for Your Daily Wellness",
    subtitle: "Lab-tested supplements trusted by thousands",
    discount: "Up to 40% Off",
    features: ["Lab Tested", "FDA Approved", "Free Delivery"],
    image: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=600&h=400&fit=crop",
    bgColor: "from-blue-700 via-blue-600 to-cyan-600",
  },
  {
    id: 3,
    title: "Complete Healthcare Solutions at Your Doorstep",
    subtitle: "From prescription medicines to daily health essentials",
    discount: "Up to 35% Off",
    features: ["Clinically Proven", "Licensed Pharmacy", "24/7 Support"],
    image: "https://images.unsplash.com/photo-1671108503276-1d3d5ab23a3a?w=600&h=400&fit=crop",
    bgColor: "from-purple-700 via-purple-600 to-indigo-600",
  },
];

export const flashSale = {
  title: "Flash Sale",
  subtitle: "Up to 50% OFF on selected items!",
  endDate: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000), // 3 days from now
};

export const products = [
  {
    id: 1,
    name: "A Ret Gel 0.025% (20gm)",
    price: 31.0,
    originalPrice: 45.0,
    rating: 4.2,
    reviewCount: 156,
    inStock: true,
    discount: 31,
    image: "https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=300&h=300&fit=crop",
    category: "skincare",
  },
  {
    id: 2,
    name: "Austro Ivermectin 12 mg",
    price: 100.0,
    originalPrice: 150.0,
    rating: 4.5,
    reviewCount: 428,
    inStock: false,
    discount: 33,
    image: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=300&h=300&fit=crop",
    category: "prescription",
  },
  {
    id: 3,
    name: "Cenforce 100mg Tablets",
    price: 45.0,
    originalPrice: 65.0,
    rating: 4.7,
    reviewCount: 892,
    inStock: true,
    discount: 31,
    image: "https://images.unsplash.com/photo-1550572017-edd951aa8f72?w=300&h=300&fit=crop",
    category: "mens-health",
  },
  {
    id: 4,
    name: "Vitamin D3 5000IU Softgels",
    price: 25.0,
    originalPrice: 35.0,
    rating: 4.8,
    reviewCount: 1205,
    inStock: true,
    discount: 29,
    image: "https://images.unsplash.com/photo-1559757175-7cb057fba93c?w=300&h=300&fit=crop",
    category: "vitamins",
  },
  {
    id: 5,
    name: "Omega-3 Fish Oil 1000mg",
    price: 35.0,
    originalPrice: 50.0,
    rating: 4.6,
    reviewCount: 678,
    inStock: true,
    discount: 30,
    image: "https://images.unsplash.com/photo-1556227834-09f1de7a7d14?w=300&h=300&fit=crop",
    category: "vitamins",
  },
  {
    id: 6,
    name: "Retinol Serum 2.5%",
    price: 55.0,
    originalPrice: 80.0,
    rating: 4.4,
    reviewCount: 345,
    inStock: true,
    discount: 31,
    image: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=300&h=300&fit=crop",
    category: "skincare",
  },
  {
    id: 7,
    name: "Biotin 10000mcg Capsules",
    price: 20.0,
    originalPrice: 30.0,
    rating: 4.5,
    reviewCount: 567,
    inStock: true,
    discount: 33,
    image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=300&h=300&fit=crop",
    category: "vitamins",
  },
  {
    id: 8,
    name: "Hyaluronic Acid Moisturizer",
    price: 42.0,
    originalPrice: 60.0,
    rating: 4.3,
    reviewCount: 234,
    inStock: false,
    discount: 30,
    image: "https://images.unsplash.com/photo-1611930022073-b7a4ba5fcccd?w=300&h=300&fit=crop",
    category: "skincare",
  },
  {
    id: 13,
    name: "Testosterone Booster Pro",
    price: 65.0,
    originalPrice: 89.0,
    rating: 4.6,
    reviewCount: 432,
    inStock: true,
    discount: 27,
    image: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=300&h=300&fit=crop",
    category: "mens-health",
  },
  {
    id: 14,
    name: "Hair Growth Formula for Men",
    price: 48.0,
    originalPrice: 70.0,
    rating: 4.4,
    reviewCount: 289,
    inStock: true,
    discount: 31,
    image: "https://images.unsplash.com/photo-1585435557343-3b092031a831?w=300&h=300&fit=crop",
    category: "mens-health",
  },
  {
    id: 15,
    name: "Women's Multivitamin Complex",
    price: 32.0,
    originalPrice: 45.0,
    rating: 4.7,
    reviewCount: 567,
    inStock: true,
    discount: 29,
    image: "https://images.unsplash.com/photo-1559757175-7cb057fba93c?w=300&h=300&fit=crop",
    category: "womens-health",
  },
  {
    id: 16,
    name: "Prenatal Vitamins DHA",
    price: 38.0,
    originalPrice: 55.0,
    rating: 4.9,
    reviewCount: 892,
    inStock: true,
    discount: 31,
    image: "https://images.unsplash.com/photo-1550572017-edd951aa8f72?w=300&h=300&fit=crop",
    category: "womens-health",
  },
  {
    id: 17,
    name: "Menopause Support Formula",
    price: 42.0,
    originalPrice: 60.0,
    rating: 4.5,
    reviewCount: 345,
    inStock: true,
    discount: 30,
    image: "https://images.unsplash.com/photo-1556227834-09f1de7a7d14?w=300&h=300&fit=crop",
    category: "womens-health",
  },
  {
    id: 18,
    name: "Anti-Aging Night Cream",
    price: 68.0,
    originalPrice: 95.0,
    rating: 4.6,
    reviewCount: 678,
    inStock: true,
    discount: 28,
    image: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=300&h=300&fit=crop",
    category: "skincare",
  },
  {
    id: 19,
    name: "Vitamin C Brightening Serum",
    price: 45.0,
    originalPrice: 65.0,
    rating: 4.8,
    reviewCount: 1023,
    inStock: true,
    discount: 31,
    image: "https://images.unsplash.com/photo-1611930022073-b7a4ba5fcccd?w=300&h=300&fit=crop",
    category: "skincare",
  },
  {
    id: 20,
    name: "Prostate Health Support",
    price: 55.0,
    originalPrice: 75.0,
    rating: 4.5,
    reviewCount: 456,
    inStock: true,
    discount: 27,
    image: "https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=300&h=300&fit=crop",
    category: "mens-health",
  },
];

export const bestSellers = [
  {
    id: 9,
    name: "Modafinil 200mg",
    price: 89.0,
    originalPrice: 120.0,
    rating: 4.9,
    reviewCount: 2341,
    inStock: true,
    discount: 26,
    image: "https://images.unsplash.com/photo-1585435557343-3b092031a831?w=300&h=300&fit=crop",
    category: "prescription",
    badge: "Best Seller",
  },
  {
    id: 10,
    name: "Zinc Picolinate 50mg",
    price: 18.0,
    originalPrice: 25.0,
    rating: 4.7,
    reviewCount: 1876,
    inStock: true,
    discount: 28,
    image: "https://images.unsplash.com/photo-1550572017-edd951aa8f72?w=300&h=300&fit=crop",
    category: "vitamins",
    badge: "Top Rated",
  },
  {
    id: 11,
    name: "Sildenafil 100mg",
    price: 55.0,
    originalPrice: 85.0,
    rating: 4.8,
    reviewCount: 3456,
    inStock: true,
    discount: 35,
    image: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=300&h=300&fit=crop",
    category: "mens-health",
    badge: "Hot Deal",
  },
  {
    id: 12,
    name: "Magnesium Glycinate 400mg",
    price: 28.0,
    originalPrice: 40.0,
    rating: 4.6,
    reviewCount: 1234,
    inStock: true,
    discount: 30,
    image: "https://images.unsplash.com/photo-1559757175-7cb057fba93c?w=300&h=300&fit=crop",
    category: "vitamins",
    badge: "Popular",
  },
];

export const features = [
  {
    icon: "Truck",
    title: "Free Shipping",
    description: "On orders over $50",
  },
  {
    icon: "Shield",
    title: "100% Genuine",
    description: "FDA Approved Products",
  },
  {
    icon: "RefreshCw",
    title: "Easy Returns",
    description: "30-day return policy",
  },
  {
    icon: "Headphones",
    title: "24/7 Support",
    description: "Expert assistance",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop",
    rating: 5,
    comment: "Excellent service! Fast delivery and genuine products. I've been ordering my vitamins here for months.",
    date: "2 days ago",
  },
  {
    id: 2,
    name: "Michael Chen",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
    rating: 5,
    comment: "Best prices I've found online. Customer support was very helpful with my prescription order.",
    date: "1 week ago",
  },
  {
    id: 3,
    name: "Emily Davis",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop",
    rating: 4,
    comment: "Great selection of skincare products. Packaging was secure and delivery was on time.",
    date: "2 weeks ago",
  },
];

export const footerLinks = {
  company: [
    { label: "About Us", href: "#about" },
    { label: "Contact Us", href: "#contact" },
    { label: "Careers", href: "#careers" },
    { label: "Press", href: "#press" },
  ],
  support: [
    { label: "Help Center", href: "#help" },
    { label: "Track Order", href: "#track" },
    { label: "Shipping Info", href: "#shipping" },
    { label: "Returns", href: "#returns" },
  ],
  legal: [
    { label: "Privacy Policy", href: "#privacy" },
    { label: "Terms of Service", href: "#terms" },
    { label: "Cookie Policy", href: "#cookies" },
    { label: "HIPAA Compliance", href: "#hipaa" },
  ],
};
